/**
 * Интервал между блоками в каруселе
 *
 * @name constants.CELL_SPACING_DATA
 * @type {Record<string, number>}
 */
export const CELL_SPACING_DATA: Record<string, number> = {
    desktop: 6,
    sDesktop: 2,
};

/**
 * Медиавыражения для определения соответствия документа определенному разрешению
 *
 * @name data.EMediaWidth
 * @type {enum}
 */
export enum EMediaWidth {
    desktop = '(min-width: 1601px)',
    sDesktop = '(max-width: 1567px)',
    laptop = '(max-width: 1279px)',
}

/**
 * Переломное разрешение для карусели (по нему определяется кол-во слайдов)
 *
 * @name constants.sDesktopMedia
 * @type {string}
 */
export const sDesktopMedia = '(min-width: 1280px)';

/**
 * Минимальное кол-во карточек для создания карусели
 *
 * @name constants.needCountCarousel
 * @type {number}
 */
export const needCountCarousel = 3;

/**
 * Минимальное кол-во карточек для создания карусели (Laptop)
 *
 * @name constants.needCountCarouselLaptop
 * @type {number}
 */
export const needCountCarouselLaptop = 2;

/**
 * Один слайд
 *
 * @name constants.ONE_SLIDE
 * @type {number}
 */
export const ONE_SLIDE = 1;

/**
 * Два слайда
 *
 * @name constants.TWO_SLIDES
 * @type {number}
 */
export const TWO_SLIDES = 2;

/**
 * Атрибуты для тестирования
 *
 * @name constants.TEST_NAMES_ATTR
 * @type {{title: string, subTitle: string, carousel: string, routerCard: string, container: string}}
 */
export const TEST_NAMES_ATTR = {
    title: 'title',
    subTitle: 'subTitle',
    carousel: 'carousel',
    routerCard: 'router-card',
    container: 'container',
};
